import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import { alias } from "@ember/object/computed"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import moment from "cc-frontend/utils/extended-moment"
import _ from "lodash"
import findDocument from "../../helpers/find-document"
import { decorateDates } from "../../lib/date-formatter"

export default class PlanbookMonthController extends Controller {
  @service("ember-store")
  store

  queryParams = [
    "startDate",
    "endDate",
    "classesLinedUp",
    "isFilteringClasses",
    "courseIds",
    "headerText",
  ]

  classesLinedUp = false
  isFilteringClasses = false
  courseIds = []

  @findDocument("model.planbookId", "planbook")
  planbook

  @alias("model.courses")
  courses

  @belongsTo("planbook", "rotationCalendar")
  rotationCalendar

  @computed("courses")
  get visibleCourses() {
    if (get(this, "isFilteringClasses") === true) {
      return _.compact(
        _.map(get(this, "courseIds"), (id) =>
          _.find(get(this, "model.courses"), (course) => get(course, "id") === id)
        )
      )
    } else {
      return get(this, "courses")
    }
  }

  // If it's the week view, we replace. Otherwise, we append
  @computed("startDate", "endDate", "rotationCalendar.content.attributes.schoolDays")
  get weeks() {
    let validSchoolDays = get(this, "rotationCalendar.content.attributes.schoolDays")

    let startDate = get(this, "startDate")
    let endDate = get(this, "endDate")

    let range = moment.range(startDate, endDate)
    let acc = []
    Array.from(range.by("days")).map((moment) => {
      if (_.includes(validSchoolDays, moment.weekday())) acc.push(moment)
    })
    let newDates = _.chain(acc)
      .map((m) => m.format("YYYY-MM-DD"))
      .thru((array) => decorateDates(array, null))
      .chunk(5)
      .value()

    return newDates
  }

  @computed("weeks.length")
  get dateRangeString() {
    if (get(this, "weeks.length") === 0) return
    let middle = Math.floor(get(this, "weeks.length") / 2)
    let middleDate = get(this, "weeks")[middle][3]
    return moment(middleDate.dateString).format("MMMM YYYY")
  }
}
